var _path, _path2, _path3, _path4, _line, _line2, _line3, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReqApprovedStamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 71,
    viewBox: "0 0 77 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.874 10.8285C36.0672 11.8979 32.0385 14.3401 29.5827 18.0873C27.5624 21.1703 26.3813 24.744 23.4959 27.3572C20.4219 30.1408 17.9277 31.5984 13.5811 32.0299C-2.26892 33.6044 -1.637 56.1902 13.1908 65.1798C28.0187 74.1695 60.016 72.9794 69.2511 46.9424C78.4862 20.9054 64.96 13.8257 53.8386 11.0165C49.7912 9.99391 45.1305 9.88166 40.874 10.8285Z",
    fill: "#E7EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9223 49.4453H8.43116L6.94556 55.8944H62.4079L60.9223 49.4453Z",
    fill: "#E7EDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1289 37.1979C40.412 37.625 44.4217 38.9062 48.271 38.9062C52.1203 38.9062 55.6489 37.4826 57.4131 36.3437C58.183 36.0021 59.1774 35.0625 59.3378 35.0625",
    stroke: "#FF8165",
    strokeWidth: 1.93473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.293 15.1724C49.8266 16.2004 52.3601 15.1724 52.3601 15.1724M52.3601 15.1724C52.3601 15.1724 56.4138 14.1444 56.4138 11.0603C56.4138 6.94827 54.387 5.40625 47.7997 5.40625C41.7192 5.40625 38.6789 7.14965 38.6789 11.0603C38.6789 13.9388 41.3814 15.3437 42.7326 15.6864V24.9385C42.7326 27.5086 39.2471 29.2011 38.1722 29.5646C36.6521 30.0786 34.6252 31.6206 34.6252 33.6766C34.6252 35.3215 34.6252 38.8167 34.6252 40.3587C35.132 42.2434 38.3749 46.0128 47.293 46.0128C56.2111 46.0128 59.4541 42.2434 59.9608 40.3587V33.6766C59.9608 32.4773 59.9608 30.5926 57.934 29.5646C55.4933 28.3267 51.8534 27.5086 51.8534 25.4525C51.8534 23.8077 52.2081 18.0851 52.3601 15.1724Z",
    stroke: "#081E54",
    strokeWidth: 1.93473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.8848,
    y1: 22.142,
    x2: 34.1649,
    y2: 22.142,
    stroke: "#1552E8",
    strokeWidth: 1.93473,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.8707,
    y1: 26.267,
    x2: 33.1507,
    y2: 26.267,
    stroke: "#1552E8",
    strokeWidth: 1.93473,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17.858,
    y1: 30.3764,
    x2: 27.0709,
    y2: 30.3764,
    stroke: "#1552E8",
    strokeWidth: 1.93473,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8878 49.9448L62.4079 55.8978H5.65576L15.7901 17.2031H35.0453",
    stroke: "#081E54",
    strokeWidth: 1.93473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7107 34.4262C3.7107 35.2344 3.05924 35.8869 2.25895 35.8869C1.45865 35.8869 0.807199 35.2344 0.807199 34.4262C0.807199 33.6179 1.45865 32.9654 2.25895 32.9654C3.05924 32.9654 3.7107 33.6179 3.7107 34.4262Z",
    stroke: "#081E54",
    strokeWidth: 0.618304
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5745 30.6801C67.5745 30.2145 67.9517 29.836 68.4174 29.836L75.66 29.8359C76.1248 29.8359 76.502 30.2136 76.502 30.6801C76.502 31.1465 76.1248 31.5233 75.66 31.5233L68.4165 31.5233C67.9517 31.5233 67.5737 31.1456 67.5737 30.6801L67.5745 30.6801Z",
    fill: "#0D318B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1563 34.2705L71.1563 27.016C71.1563 26.5505 71.5334 26.1719 71.9991 26.1719C72.4648 26.1719 72.8411 26.5496 72.8411 27.016L72.8411 34.2705C72.8411 34.736 72.4639 35.1146 71.9991 35.1146C71.5343 35.1146 71.1563 34.7369 71.1563 34.2705Z",
    fill: "#0D318B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5774 16.2055C67.5774 15.8935 67.8276 15.6406 68.1363 15.6406L72.9426 15.6406C73.2513 15.6406 73.5015 15.8934 73.5015 16.2054C73.5015 16.5175 73.2513 16.7703 72.9426 16.7703L68.1363 16.7703C67.8276 16.7703 67.5774 16.5175 67.5774 16.2055Z",
    fill: "#3A6EEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9819 18.6336L69.9819 13.7758C69.9819 13.4637 70.2321 13.2109 70.5408 13.2109C70.8495 13.2109 71.0996 13.4637 71.0996 13.7758L71.0996 18.6336C71.0996 18.9456 70.8495 19.1984 70.5408 19.1984C70.2321 19.1984 69.9819 18.9456 69.9819 18.6336Z",
    fill: "#3A6EEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqApprovedStamp);
export default __webpack_public_path__ + "static/media/ReqApprovedStamp.2d605ff1acbefe97224df903771c89fe.svg";
export { ForwardRef as ReactComponent };